// Translate an inbox `lesson` item payload into the Lesson shape that
// the lesson runner (Lesson.jsx, via utils/lessonRoutes.openLesson) expects.
// Shared by <Inbox> and useNextLesson().
export const lessonShapeFromItem = (item) => {
  const p = item.payload || {};
  return {
    id: p.lesson_id,
    name: p.name,
    lesson_type: p.lesson_type,
    source: p.source,
    source_collection: p.source_collection,
    status: p.status,
    word_count: p.word_count,
    total_questions: p.total_questions,
    // Payloads that predate `correct` count every answer as correct.
    correct_answers: p.correct ?? (p.answered || 0),
    incorrect_answers: p.correct != null ? Math.max(0, (p.answered || 0) - p.correct) : 0,
    started_at: p.started_at,
    // The user's learned seconds per answer for this lesson type (backend
    // lesson_pace: tracked time shrunk toward a per-type prior).
    seconds_per_question: p.seconds_per_question,
  };
};

// Progress as shown to the user: only correct answers count. A miss
// re-queues a retry that adds to total_questions, so it is taken out of the
// total too — 20 words with 4 misses read 20/20 when done, not 24/24.
export const successProgress = (lesson) => {
  const correct = lesson?.correct_answers || 0;
  const total = Math.max(0, (lesson?.total_questions || 0) - (lesson?.incorrect_answers || 0));
  return { done: Math.min(correct, total), total };
};

// Used only when a payload predates seconds_per_question.
const FALLBACK_SECONDS_PER_QUESTION = 45;

export const remainingQuestions = (lesson) =>
  lesson
    ? Math.max(0, (lesson.total_questions || 0) - (lesson.correct_answers || 0) - (lesson.incorrect_answers || 0))
    : 0;

// "ca. N min" for the questions still open; 0 when nothing is left.
export const estimateRemainingMinutes = (lesson) => {
  const remaining = remainingQuestions(lesson);
  if (remaining === 0) return 0;
  const pace = Number(lesson.seconds_per_question) > 0
    ? Number(lesson.seconds_per_question)
    : FALLBACK_SECONDS_PER_QUESTION;
  return Math.max(1, Math.round((remaining * pace) / 60));
};
